import React from 'react'
import { connect } from 'react-redux'

import BasicLgyCheckbox from 'app/components/util/lgy-checkbox/BasicLgyCheckbox'
import { updateVisibilityStatus } from '../actions/correspondenceActions'

const VisbilitySetting = ({ document, auditId, auditUnit, correspondence, updateVisibilityStatus, user }) => {
  let { id, viewableToExternal, viewableToMonitoringUnit, viewableToQualityAssurance, viewableToThirdParty, createdByName } = document

  const isExternalUser = user.authorizations.includes('ROLE_External Oversight User')
  const isThirdPartyUser = user.authorizations.includes('ROLE_VA Third Party Oversight')
  //TODO: this should probably be portal id in case of same names
  const thisUserName = `${user.firstName} ${user.lastName}`

  const handleChange = (event) => {
    updateVisibilityStatus(event.target.name, auditId, id)
  }

  return <fieldset className='usa-fieldset-inputs usa-sans'>
    <legend className='usa-sr-only'>Change Visibility for document</legend>
    <ul className='usa-unstyled-list'>
      {auditUnit === 'M' && <li>
        <BasicLgyCheckbox id={`${document.id}-mu`} name='MU' label='MU' checked={viewableToMonitoringUnit} disabled />
      </li>}
      {auditUnit === 'Q' && <li>
        <BasicLgyCheckbox id={`${document.id}-qa`} name='QA' label='QA' checked={viewableToQualityAssurance} disabled />
      </li>}
      <li>
        <BasicLgyCheckbox id={`${document.id}-ex`} name='EX' label='External' checked={viewableToExternal}
          onChange={handleChange} disabled={isExternalUser || thisUserName !== createdByName || correspondence.fetching} />
      </li>
      <li>
        {auditUnit === 'Q' && <BasicLgyCheckbox id={`${document.id}-tp`} name='TP' label='VA Third Party' checked={viewableToThirdParty}
          onChange={handleChange} disabled={isThirdPartyUser || thisUserName !== createdByName || correspondence.fetching} />}
      </li>
    </ul>
  </fieldset>
}

const mapStateToProps = state => ({
  correspondence: state.oversight.correspondence,
  user: state.currentUser
})

const mapDispatchToProps = { updateVisibilityStatus }

export default connect(mapStateToProps, mapDispatchToProps)(VisbilitySetting)
